import { Injectable } from '@angular/core'

import * as _ from 'lodash'

import { AuthStore } from '@api/store/auth'
import { ProfileDto } from '@api/dto'

import { HttpService } from './http.service'

@Injectable()
export class AuthService {
  constructor(
    private httpService: HttpService,
    private authStore: AuthStore) {
  }

  async current() {
    const user = await this.httpService.get<ProfileDto>('/v1/profile/admin')
    const authUser = _.clone(user)
    
    this.authStore.update({ user: authUser })

    return user
  }

  async isMerchant() {
    return await this.httpService.get<Boolean>('/merchant/v1/is-merchant')
  }

  async isAdmin() {
    return await this.httpService.get<Boolean>('/admin/v1/is-admin')
  }

  async updatePassword(currentPassword: string, newPassword: string, confirmPassword: string) {
    return await this.httpService.patch<Boolean>('/v1/auth/change-password', {
      currentPassword,
      newPassword,
      confirmPassword
    })
  }

  async logIn(email: string, password: string, shouldRemember: boolean) {
    const { sessionToken, user } = await this.httpService.post<any>('/v1/auth/login', {email, password})

    await this.httpService.setSessionToken(sessionToken, shouldRemember)

    return user
  }

  async logOut() {
    await this.httpService.delete('/v1/auth/logout')

    return await this.httpService.removeSessionToken()
  }
}
